;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"

import { useRouter, usePathname, useParams } from "next/navigation"
import styles from "./styles.module.scss"
import Typography from "@mui/material/Typography"

import Image from "next/image"
import {
  CREATED_ZESTLIFE_REASON_STAND_FOR_GROUPS,
  CREATED_ZESTLIFE_REASON_OPEN_DOORS,
  CREATED_ZESTLIFE_REASON_STRONGER_TOGETHER,
} from "../../../shared/constants"

import standForGroupsPic from "../images/stand-for-groups.jpg"
import strongerTogetherPic from "../images/stronger-together.jpg"
import openDoorsPic from "../images/open-doors.jpg"

import Grid from "@mui/material/Grid" // Grid version 2

function Reason({ reasonType }) {
  const renderHeader = () => {
    let header
    switch (reasonType) {
      case CREATED_ZESTLIFE_REASON_STAND_FOR_GROUPS:
        header = "Stand for groups"
        break
      case CREATED_ZESTLIFE_REASON_OPEN_DOORS:
        header = "Open doors"
        break
      case CREATED_ZESTLIFE_REASON_STRONGER_TOGETHER:
        header = "Stronger together"
        break
    }
    return <h2 className={styles["header"]}>{header}</h2>
  }

  const renderBody = () => {
    switch (reasonType) {
      case CREATED_ZESTLIFE_REASON_STAND_FOR_GROUPS:
        return (
          <div className={styles["body"]}>
            We are committed to mental wellness <b>groups as an effective pathway</b>{" "}
            in mental health care.
          </div>
        )
      case CREATED_ZESTLIFE_REASON_OPEN_DOORS:
        return (
          <div className={styles["body"]}>
            We believe in making great <b>groups accessible</b> to everyone,
            regardless of niche or location.
          </div>
        )
      case CREATED_ZESTLIFE_REASON_STRONGER_TOGETHER:
        return (
          <div className={styles["body"]}>
            We can effectively <b>facilitate complementary care</b> across the mental
            health field to enrich people’s lives.
          </div>
        )
    }
  }

  const renderPicture = () => {
    switch (reasonType) {
      case CREATED_ZESTLIFE_REASON_STAND_FOR_GROUPS:
        return (
          <Image
            src={standForGroupsPic}
            // width={342}
            fill
            alt={"zestlife stands for groups"}
            className={styles["grayscale"]}
          />
        )

      case CREATED_ZESTLIFE_REASON_OPEN_DOORS:
        return (
          <Image
            src={openDoorsPic}
            // height={180}
            // width={342}
            fill
            className={styles["grayscale"]}
            alt={"keep doors open for others in mental welness groups"}
          />
        )
      case CREATED_ZESTLIFE_REASON_STRONGER_TOGETHER:
        return (
          <Image
            src={strongerTogetherPic}
            fill
            alt={"groups are stronger together"}
            className={styles["grayscale"]}
          />
        )
    }
  }

  return (
    <Grid
      // margin={0}
      // padding={0}
      sx={{ display: "flex", justifyContent: "center" }}
      size={{
        xs: 7.9,
        sm: 4.5,
        md: 4,
        lg: 3,
      }}
    >
      <div className={styles["reason-container"]}>
        <div className={styles["text-container"]}>
          {renderHeader()}
          {renderBody()}
        </div>
        <div className={"relative h-[180px]"}>{renderPicture()}</div>
      </div>
    </Grid>
  )
}

export default Reason
